// src/lib/kinema/konva/interaction/KonvaViewportProvider.ts
import Konva from 'konva';
import type { ViewportProvider, Point } from '../../core/tools/types';

export class KonvaViewportProvider implements ViewportProvider {
  constructor(private stage: Konva.Stage) {}

  getOffset(): Point {
    return { x: this.stage.x(), y: this.stage.y() };
  }

  setOffset(x: number, y: number): void {
    this.stage.position({ x, y });
    this.stage.batchDraw();
  }
}
